import { withInstall } from "../utils/index.mjs";
import _ActionBarButton from "./ActionBarButton.mjs";
const ActionBarButton = withInstall(_ActionBarButton);
var stdin_default = ActionBarButton;
import { actionBarButtonProps } from "./ActionBarButton.mjs";
export {
  ActionBarButton,
  actionBarButtonProps,
  stdin_default as default
};
